<template>
  <footer class="bg-[#112415] text-stone-300 border-t border-[#1C3F24]/20 font-sans">
    <!-- Main Footer -->
    <div class="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
      <div class="grid lg:grid-cols-4 md:grid-cols-2 gap-12 text-left">
        <!-- Company Info -->
        <div class="lg:col-span-1 text-left">
          <div class="flex items-center mb-8 group">
            <div class="w-30 h-30 bg-white rounded-2xl flex items-center justify-center mr-3 shadow-md overflow-hidden">
              <img alt="Delba Logo" class="h-25 w-25 object-contain" :src="logo" />
            </div>
            
            <div class="text-left flex flex-col">
              <span class="text-md font-black tracking-tight text-white uppercase leading-tight">DELBA MARKET</span>
              <span class="text-[10px] font-bold tracking-[0.2em] text-[#C29D53] uppercase leading-none">SUPPLIES</span>
            </div>
            
          </div>
          <p class="text-stone-400 mb-8 leading-relaxed text-sm text-left font-medium">
              Poultry. Fresh Produce. Trusted Supply.
          </p>
          <p class="text-stone-400 mb-8 leading-relaxed text-sm text-left font-medium">
            Kampala's purveyor of wholesome agricultural produce. We supply fresh vegetables, fruits, dressed poultry, grains, and key food items directly to kitchens, hotels, and retail markets.
          </p>

          <div class="space-y-4">
            <div class="flex items-start text-sm">
              <MapPin class="w-4 h-4 mr-3 text-[#C29D53] flex-shrink-0 mt-0.5" />
              <span class="text-stone-300">{{ companyInfo.address }}</span>
            </div>
            <div class="flex items-center text-sm">
              <Phone class="w-4 h-4 mr-3 text-[#C29D53] flex-shrink-0" />
              <a
                :href="`tel:${companyInfo.phone}`"
                class="hover:text-white transition-colors text-stone-300"
              >
                {{ companyInfo.phone }}
              </a>
            </div>
            <div class="flex items-center text-sm">
              <Mail class="w-4 h-4 mr-3 text-[#C29D53] flex-shrink-0" />
              <a
                :href="`mailto:${companyInfo.email}`"
                class="hover:text-white transition-colors text-stone-300"
              >
                {{ companyInfo.email }}
              </a>
            </div>
          </div>

         
        </div>

        <!-- Supplies Links -->
        <div class="text-left md:pl-8">
          <h4 class="text-xs font-black mb-8 text-white uppercase tracking-[0.2em] text-left">Our Supplies</h4>
          <ul class="space-y-4 text-left">
            <li v-for="service in serviceLinks" :key="service.name">
              <router-link
                to="/Products"
                class="text-stone-400 hover:text-white transition-all duration-200 flex items-center text-sm group"
              >
                <div class="w-1.5 h-1.5 rounded-full bg-[#C29D53] mr-3 opacity-60 group-hover:opacity-100 group-hover:scale-125 transition-all"></div>
                {{ service.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Quick Links -->
        <div class="text-left md:pl-8">
          <h4 class="text-xs font-black mb-8 text-white uppercase tracking-[0.2em] text-left">Quick Links</h4>
          <ul class="space-y-4 text-left">
            <li v-for="link in quickLinks" :key="link.name">
              <router-link
                :to="link.path"
                class="text-stone-400 hover:text-white transition-all duration-200 flex items-center text-sm group"
              >
                <component :is="link.icon" class="w-4 h-4 mr-3 text-stone-500 group-hover:text-[#C29D53] transition-colors" />
                {{ link.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Brand Standards -->
        <div class="text-left">
          <h4 class="text-xs font-black mb-8 text-white uppercase tracking-[0.2em] text-left">Freshness Guaranteed</h4>
          <p class="text-sm text-stone-400 leading-relaxed mb-6 font-medium">
            From Uganda's fertile local sources right to your business or home, our supplies undergo rigorous sorting and strict grading to meet the highest culinary standards.
          </p>
          <div class="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[#1C3F24]/40 border border-[#C29D53]/20">
            <div class="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse"></div>
            <span class="text-xs text-stone-200 font-bold uppercase tracking-wider">Hygienically Sorted</span>
          </div>
           <!-- Social Links -->
          <div class="mt-8 flex items-center gap-3">
            <a
              v-for="social in socialLinks"
              :key="social.name"
              :href="social.url"
              target="_blank"
              rel="noopener noreferrer"
              class="w-10 h-10 rounded-xl bg-[#1C3F24]/40 border border-[#C29D53]/20 flex items-center justify-center hover:bg-[#C29D53] transition-all hover:-translate-y-1 text-stone-300 hover:text-white group"
              :title="social.name"
            >
              <img :src="social.icon" :alt="social.name" class="w-5 h-5 object-contain group-hover:scale-110 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Footer border -->
    <div class="border-t border-white/5 bg-[#09150c]">
      <div class="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-8">
        <div class="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <p class="text-xs text-stone-500 font-medium">
              © {{ currentYear }} DELBA MARKET SUPPLIES. All Rights Reserved.
            </p>
          </div>

          <div class="flex items-center text-xs font-bold text-stone-500 uppercase tracking-widest gap-2">
            <span class="text-stone-700">•</span>
            <span>MUNYONYO WAVAMUNNO ROAD OPPOSITE GAZ</span>
            
          </div>
          <a class="underline underline-offset-4 decoration-blue-500 decoration-2 decoration-wavy" href="https://princetechcompany.pages.dev" target="_blank" rel="noopener noreferrer">• Developed by: PTC</a> 

        </div>

      </div>

    </div>

    <!-- Floating WhatsApp Button -->
    <a
      :href="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:bg-[#20ba5a] hover:scale-110 transition-all duration-300 flex items-center justify-center group"
      aria-label="Chat on WhatsApp"
    >
      <!-- Custom SVG WhatsApp Icon -->
      <svg
        class="w-7 h-7 fill-current"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.4 0 12.008 0c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 12.002-11.948 12.002-2.005-.001-3.973-.5-5.714-1.446L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.37 9.864-9.799.002-2.63-1.023-5.101-2.885-6.965C16.628 1.977 14.163 1.948 11.531 1.95c-5.43 0-9.854 4.37-9.858 9.8.002 1.741.485 3.396 1.446 4.932l-.982 3.595 3.69-.973zm11.233-5.32c-.32-.16-1.89-.933-2.185-1.042-.295-.108-.51-.16-.724.16-.214.32-.83.1042-1.017 1.258-.187.216-.374.24-.694.08-3.136-1.571-4.346-2.701-5.614-4.884-.333-.572.333-.531.953-1.77.102-.208.051-.39-.026-.55-.076-.16-.724-1.743-.993-2.392-.262-.63-.529-.544-.724-.554-.187-.01-.402-.012-.617-.012-.215 0-.563.08-.859.401-.295.32-1.127 1.101-1.127 2.685 0 1.584 1.152 3.115 1.312 3.33.16.216 2.268 3.464 5.495 4.859.767.332 1.366.53 1.833.679.77.244 1.472.21 2.026.127.618-.093 1.891-.773 2.158-1.48.267-.708.267-1.315.187-1.44-.08-.124-.295-.208-.615-.369z"
        />
      </svg>
      <!-- Tooltip text on hover -->
      <span class="absolute right-16 bg-[#112415] text-white text-xs font-bold px-3 py-1.5 rounded-lg border border-[#C29D53]/30 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-xl">
        Order via WhatsApp
      </span>
    </a>
  </footer>
</template>

<script setup>
import logo from "@/assets/logo.png";
import {
  MapPin,
  Phone,
  Mail,
  Home,
  User,
  Briefcase,
  MessageCircle,
  Zap,

  
} from "lucide-vue-next";
import { computed } from "vue";

import facebook from "@/assets/ICONS/facebook.png"
import instagram from "@/assets/ICONS/instagram.png"
import XX from "@/assets/ICONS/XX.png"
import jiji from "@/assets/ICONS/jiji.png"
import tiktok from "@/assets/ICONS/tiktok.png"

const socialLinks = [
  { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61590623910709', icon: facebook },
  { name: 'Instagram', url: 'https://www.instagram.com/delbamarketsupplies', icon: instagram },
  { name: 'X', url: 'https://x.com/Delbamarket', icon: XX },
  { name: 'Jiji', url: 'https://jiji.ug/profile?guid=2zDEuPrs4cW8Ra9vgW17Pk4Q', icon: jiji },
  { name: 'TikTok', url: 'https://www.tiktok.com/@delbamarketsupplies', icon: tiktok }
];

const currentYear = computed(() => new Date().getFullYear());

const companyInfo = {
  address: "MUNYONYO WAVAMUNNO ROAD OPPOSITE GAZ ",
  phone: "+256 731 797 469",
  email: "info@delbamarketsupplies.com",
};

const whatsappUrl = computed(() => {
  // Cleanses formatting from the phone number to only include digits
  const cleanPhone = companyInfo.phone.replace(/\D/g, "");
  const message = encodeURIComponent(
    "Hello Delba Market Supplies! I would like to make an inquiry about your fresh produce."
  );
  return `https://wa.me/${cleanPhone}?text=${message}`;
});

const quickLinks = [
  { name: "Home", path: "/", icon: Home },
  { name: "About Us", path: "/About", icon: User },
  { name: "Products", path: "/Products", icon: Briefcase },
  { name: "Order Now", path: "/Order", icon: Zap },
  { name: "Contact Us", path: "/ContactUs", icon: MessageCircle },
];

const serviceLinks = [
  { name: "Fresh Vegetables" },
  { name: "Tropical Fruits" },
  { name: "Hygienically Dressed Poultry" },
  { name: "Organic Grains & Cereals" },
  { name: "Culinary Staples & Foods" },
];
</script>
